export default __webpack_public_path__ + "img/1154023daaa4052a5fb3daa8d851b419.png";